<template>
	<div v-if="Character.Equipment.Stored.length > 0">
		<h5 class="mt-2">Stored</h5>
		<b-table-simple responsive small bordered striped table-class="mb-0" class="mt-2" v-for="(container, containerID) in Character.Equipment.Stored" :key="'equipment-container-'+containerID">
			<b-thead>
				<b-tr>
					<b-th colspan="3" class="lead">{{container.Type}}</b-th>
					<b-th class="lead">{{container.Price}}</b-th>
					<b-th class="lead">{{container.Bulk}}</b-th>
				</b-tr>
				<b-tr>
					<b-th>Level</b-th>
					<b-th>Qty</b-th>
					<b-th>Name</b-th>
					<b-th>Unit Price</b-th>
					<b-th>Unit Bulk</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-for="(item, itemID) in container.Contents" :key="'equipment-container-'+containerID+'-item-'+itemID">
					<b-td>{{item.Level}}</b-td>
					<b-td>{{item.Qty}}</b-td>
					<b-td>{{item.Name}}</b-td>
					<b-td>{{item.UnitPrice}}</b-td>
					<b-td>{{item.UnitBulk}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>